import { TOGGLE_CREDENTIAL_GROUP_FORM, TOGGLE_CREDENTIAL_GROUP_VIEW } from 'constants/ActionTypes';

// Handles credential group view modal
export const toggleCredentialGroupView = (groupId = null) => {
  return {
    type: TOGGLE_CREDENTIAL_GROUP_VIEW,
    groupId,
  };
};

// Handles credential group form modal
export const toggleCredentialGroupForm = (groupId = null) => {
  return {
    type: TOGGLE_CREDENTIAL_GROUP_FORM,
    groupId,
  };
};
